module.exports = __webpack_public_path__ + "img/mission_add_image.79772c0.png";